<template
  ><div>
    <div class="nav_main">
      <div class="navigation">
        <router-link to="/" class="logo">
          <img src="../assets/source/images/logo_happytable.png" />
        </router-link>
        <div class="right">
          <div class="main-list">
            <ul
              class="main-list__title"
              @mouseover="doMouseOver"
              @touchend="doMouseOver"
            >
              <li class="item">
                <router-link
                  to="/happytable"
                  :class="{menuActive: isActive('happytable')}"
                  >해피테이블</router-link
                >
              </li>
              <li class="item">
                <router-link
                  to="/productinfo"
                  :class="{menuActive: isActive('productinfo')}"
                  >제품 소개</router-link
                >
              </li>
              <li class="item">
                <router-link
                  to="/cognition"
                  :class="{menuActive: isActive('cognition')}"
                  >게임 소개</router-link
                >
              </li>

              <!-- <li class="item">
                <router-link
                  to="/cognition"
                  :class="{menuActive: isActive('cognition')}"
                  >인지 평가 게임</router-link
                >
              </li> -->

              <li class="item">
                <router-link to="/news" :class="{menuActive: isActive('news')}"
                  >소 식</router-link
                >
              </li>
              <li class="item"></li>
            </ul>
          </div>
          <div class="icon">
            <div class="instagram-icon">
              <a
                href="https://www.instagram.com/happytable_official/"
                target="_blank"
              >
                <img
                  src="../assets/source/images/ic_sns_insta.png"
                  alt="go to instagram"
                />
              </a>
            </div>
            <div class="facebook-icon">
              <a
                href="https://www.facebook.com/happytable2020/?ref=bookmarks"
                target="_blank"
              >
                <img
                  src="../assets/source/images/ic_sns_facebook.png"
                  alt="go to instagram"
                />
              </a>
            </div>

            <div class="kakao-icon">
              <a href="http://pf.kakao.com/_xjYRxab" target="_blank">
                <img
                  src="../assets/source/images/ic_sns_kakao.png"
                  alt="go to kakao"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <transition name="fade">
        <div
          class="dropdown-menu"
          :class="{active: is_active == true}"
          @mouseout="mouseFocusOut"
          @mouseover="doMouseOver"
        >
          <div class="menu-background">
            <p class="sub-menu">
              <router-link to="/happytable"
                ><span class="text">브랜드 이야기</span></router-link
              >
              <router-link to="/happytable/award"
                ><span>인증 / 수상</span></router-link
              >
              <router-link to="/happytable/update"
                ><span>버전 3.5</span></router-link
              >
            </p>
            <p class="sub-menu">
              <router-link to="/productinfo/"><span>43 인치</span></router-link>
              <router-link to="/productinfo/32inch"
                ><span>32 인치</span></router-link
              >
              <router-link to="/productinfo/happytablet"
                ><span>해피태블릿</span></router-link
              >
            </p>
            <!-- <p class="sub-menu game">
              <router-link to="/game?index=0" class="game-title"
                ><span>전 체</span></router-link
              >
              <router-link to="/game?index=1"><span>경 쟁</span></router-link>
              <router-link to="/game?index=2"><span>협 동</span></router-link>
              <router-link to="/game?index=3"><span>힐 링</span></router-link>
              <router-link to="/game?index=4"><span>학 습</span></router-link>
            </p> -->
            <p class="sub-menu">
              <router-link to="/cognition/"
                ><span>기능성 게임</span></router-link
              >
              <router-link to="/cognition/multigame"
                ><span>멀티 게임</span></router-link
              >
              <router-link to="/cognition/cognition"
                ><span>인지 평가 게임</span></router-link
              >
            </p>
            <p class="sub-menu">
              <router-link to="/news"><span>공지 사항</span></router-link>
              <router-link to="/news/reference"
                ><span>설치 사례</span></router-link
              >
              <router-link to="/news/faq"><span>FAQ</span></router-link>
            </p>
            <p class="sub-menu last-menu"></p>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import items from "../assets/source/json/menu.json";
export default {
  data() {
    return {
      pages: items,
      is_true: false,
      is_first: false,
      menu_kind: "",
      is_active: false,
      is_mobile: false,
      is_mobile_open: false,
      isHambugShow: false,
      gameIndex: 0,
    };
  },

  computed: {},
  created() {
    this.check_mobile();
  },
  mounted() {
    window.addEventListener("resize", this.check_mobile);
    window.addEventListener("touchmove", this.mouseFocusOut);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.check_mobile);
    window.removeEventListener("touchmove", this.mouseFocusOut);
  },
  watch: {
    $route() {
      if (this.is_mobile_open == true) {
        this.openMenu();
      }
    },
  },
  methods: {
    isActive(menuName) {
      if (menuName === this.$route.path.split("/")[1]) {
        return true;
      } else {
        return false;
      }
    },
    doMouseOver() {
      this.is_active = true;
    },

    mouseFocusOut() {
      this.is_active = false;
    },

    clickMenu(menuName, index) {
      if (
        menuName === this.$route.name &&
        index === parseInt(this.$route.query.index)
      ) {
        return;
      }
      //여기서 라우트 푸쉬로 인덱스를 넘긴다.
      this.$router.push({
        name: menuName,
        query: {index: index},
      });
    },

    doMouseLeave: function() {
      if (window.innerWidth > 1024) {
        this.is_true = false;
        this.is_active = false;
      }
    },
    check_mobile() {
      if (window.innerWidth <= 1024) {
        this.is_mobile = true;
      } else {
        this.is_mobile = false;
      }
    },
    checkBrowserWidth() {
      this.isHambugShow = window.innerWidth <= 1023;
    },
    openMenu() {
      if (this.is_mobile_open == false) {
        this.is_mobile_open = true;
        document.querySelector("body").style.overflow = "hidden";
      } else {
        this.is_mobile_open = false;
        document.querySelector("body").style.overflow = "scroll";
      }
    },
    mobileMenu() {
      if (window.innerWidth < 768) {
        this.is_active = true;
        this.is_true = true;
      }
    },
    check_menu_kind(menu_kind, main_menu) {
      if (window.innerWidth < 768) {
        this.is_active = true;
        this.is_true = true;
        return true;
      } else {
        if (menu_kind == main_menu) {
          return true;
        } else {
          return false;
        }
      }
    },
  },
};
</script>

<style scoped>
.menuActive {
  color: #f83f1b !important;
  border-bottom: none !important;
}

* {
  margin: 0;
  padding: 0;
}
a {
  text-decoration: none;
  display: block;
}
a:visited {
  color: black;
}
.d_none {
  display: none;
}
.d_block {
  display: block;
}
.mobile.d_none {
  display: block;
}
ul.active {
  /* border: 1px solid #333333; */
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);
  /* border-radius: 20px; */
  position: absolute;
  margin: 0 1rem;
  padding: 0.5rem 0;
}

a.logo {
  display: flex;
  align-items: center;
}
a.imgWrap img {
  width: 100%;
}
.nav_main {
  position: fixed;
  width: 100%;

  background: white;
  z-index: 99;
  border-bottom: 1px solid #dddddd;
  height: 70px;
}
.navigation {
  display: flex;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
}
.right {
  display: flex;
}
.icon {
  display: flex;
  align-items: center;
}

.main-list {
  background-color: #ffffff;
}

.main-list .main-list__title {
  display: table-row;
  height: 70px;
  font-weight: 600;
}

.item a {
  min-width: 120px;
}
.item a:hover {
  color: #f83f1b !important;
}
.sub-menu a:hover {
  color: #f83f1b !important;
  font-weight: 600;
}
.item:hover .dropdown-menu {
  display: block;
}
.main-list .main-list__title .item {
  position: relative;
  padding-left: 2.5rem;
  display: table-cell;
  vertical-align: middle;
  cursor: pointer;
  font-size: 1rem;
}

.instagram-icon,
.facebook-icon {
  margin-right: 0.5rem;
}

.dropdown-menu.active {
  display: block;
}

.dropdown-menu {
  position: absolute;
  width: 100%;
  display: none;
  background-color: #ffffff;
  border-bottom: 1px solid #e6e6e6;
  /* padding: 0 2rem 1.5rem 2rem; */
}
.dropdown-menu .menu-background {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: right;
}

.dropdown-menu .menu-background .sub-menu {
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 158px;
}

.dropdown-menu .menu-background .sub-menu.last-menu {
  width: 155px;
}

.sub-menu a {
  margin-bottom: 0.8rem;
  margin-left: auto;
  margin-right: auto;
  cursor: pointer;
}

.router-link-exact-active {
  color: #f83f1b;
  font-weight: 600;
  border-bottom: 1px solid #f83f1b;
}

.sub-menu {
  padding: 1.1rem 0 3rem;
  /* font-size: 1.2rem; */
  font-size: 15px;
}

.sub-menu.table {
  margin: 0 2.5rem 0 3.3rem;
}
.sub-menu.game {
  margin: 0 2.4rem;
}

.sub-menu.game-story {
  margin-left: 3.1rem;
}

.sub-menu.news {
  margin-left: 3.3rem;
}
@media (min-width: 1024px) {
  .navigation {
    padding: 0 2rem;
  }
}

@media (max-width: 1023px) {
  .navigation[data-v-535fe4d6] {
    display: flex;
    justify-content: space-between;
    max-width: 1200px;
    margin: 0 auto;
    padding-left: 20px;
  }
}

@media (min-width: 1281px) and (max-width: 1440px) {
  .sub-menu.last-menu {
    width: 169px;
  }
}

@media (min-width: 1240px) and (max-width: 1280px) {
  .sub-menu.last-menu {
    width: 171px;
  }
}

@media (min-width: 1025px) and (max-width: 1239px) {
  .sub-menu.last-menu {
    width: 201px;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  ul.active {
    border: 1px solid #333333;
    border-radius: 20px;
    position: absolute;
    margin: 0;
    padding: 0.5rem 0;
  }
  ul.active li {
    width: unset !important;
    display: block;
    padding: 0 1.5rem;
    text-align: left;
    line-height: 2rem;
  }
  ul.main li {
    width: auto;
    padding: 0 1rem;
  }
}
@media (max-width: 767px) {
  a.logo {
    height: 64px;
  }
  .logo .com_logo {
    left: 20%;
  }
  .mobile_menu {
    height: 64px;
  }
  /* .menu_icon {
    height: 50px;
    width: 50px;
    position: absolute;
    top: 10%;
  }*/
  .menu_icon img {
    width: 100%;
  }

  .imgWrap img {
    width: 200px;
  }
  ul.active {
    border: 0px;
    position: inherit;
    margin: unset;
    padding: 0.5rem 0;
  }
  ul.main li {
    width: 8rem;
    line-height: 2.6rem;
    display: block;
  }

  .main_list.active {
    display: block;
    position: absolute;
    width: 100%;
    top: 64px;
    left: -10%;
    padding-left: 10%;
    background: white;
    height: 100vh;
    text-align: left;
  }
  .main_list {
    display: none;
  }
  .nav_main {
    height: 70px;
  }
  .mobile.d_none span {
    font-size: 14px;
    color: gray;
  }
  .main li div {
    /* border-bottom: 1px solid gray; */
    width: 90%;
  }
  .main li {
    /* border-bottom: 1px solid gray; */
    /* width: 90% !important; */
    text-align: left;
  }
  .main li:last-child {
    border-bottom: 0px;
  }
}
@media (max-width: 300px) {
  .imgWrap img {
    width: 150px;
  }
}
</style>
